var map = {
	"./1. Greening the Philippine pandemic response.jpg": "0178",
	"./1. Impact of the transition to electrical vehicles.jpg": "b84e",
	"./1_Social_Ecological_Transformation_in_Vietnam _ENG_frontcover.jpg": "1952",
	"./2. Prospects_for_a_Socially_Just_Transition_in_VietNam_frontcover.jpg": "5d41",
	"./2_Criteria_Sustainable_Urban_Communities_Cities_Vietnam_frontcover.jpg": "e5f1",
	"./3_Hanoi_mobility_study_frontcover.jpg": "7d51",
	"./4_Mobility_gender_frontcover.jpg": "7abe",
	"./A Socially Equitable Energy Transition in Indonesia.jpg": "e191",
	"./AQI-la_against_air_pollution.png": "8a6a",
	"./Afloat - the rise, the fall, the ebb of Mumbais communities by the water.png": "4d38",
	"./Aquifer mapping.jpg": "7fae",
	"./Artificial Intellignce in Asia.jpg": "dd93",
	"./Aspiration of an urban transformation in Asia.jpg": "36a7",
	"./Bengaluru Mobility Cover.png": "4c62",
	"./Bengaluru_cover.jpg": "2620",
	"./Chennai.png": "a29d",
	"./China India exchange.jpg": "991b",
	"./Circular economy in India.png": "ee20",
	"./Cities_as_places_for_transformation.png": "46e4",
	"./Energy Transition in Thailand.jpg": "1c0d",
	"./Evaluation_Recommendation_SouthKorea.png": "dfe3",
	"./FES-Jakarta-RZ033.jpg": "de15",
	"./From Hanoi to Katowice.png": "4dfc",
	"./Gender_blindness.png": "fce3",
	"./INFOGRAPHIC_Are we on track on the 1.5 degree climate path.png": "4581",
	"./In Pursuit of a Low Fossil Energy Future.jpg": "5909",
	"./Jakarta - A city on the move.png": "16b9",
	"./Jakarta - an adventure in urban planning.jpg": "675b",
	"./Jakarta_mobility_study_frontcover.jpg": "34b2",
	"./Jakarta_s Future in Sustainable Housing.png": "67e2",
	"./Leaving no one behind in Vietnam_s energy transition.png": "e1a2",
	"./Manila Mobility Cover_Page_01.png": "4997",
	"./Metro Manila.jpg": "3cf3",
	"./Mumbai_TCM Workshop.jpg": "06b0",
	"./Not just roads.jpg": "542a",
	"./People oriented planning.jpg": "6819",
	"./RIVERse-Exhibition-Mumbai.jpg": "6919",
	"./Renewing Forgotten Flows.jpg": "5a53",
	"./Renewing Forgotten Flows_new.jpg": "85a1",
	"./Shifting investments from fossil fuels in Southeast Asia.png": "4a37",
	"./Smart_mobility_INdia.png": "6838",
	"./Social-ecological transformation in cities in Asia.png": "c77b1",
	"./Strategising for Mumbais Urban Transformation using the Power of Narrative.jpg": "f7d0",
	"./Strategy for A Social City in Indonesia.jpg": "1740",
	"./Summary_mobility_studies_frontcover.jpg": "8737",
	"./The urban housing crises of Indonesia and Malaysia.jpg": "e944",
	"./Transforming urban water management in India.png": "6125",
	"./Urban space cannot be fragmented into commodities.jpg": "7706",
	"./Urban_spcaes_Green-spaces.png": "0669",
	"./Who owns the city.jpg": "721b",
	"./Y4JT Justice League.jpeg": "e3ba",
	"./cc1-social-ecological-transformation.png": "9494",
	"./cc2-shifting-investments.jpg": "efba",
	"./cc3-gender-perspectives.png": "6b89",
	"./cc4-towards-a-just-transition.png": "cee9",
	"./cc5-crossing-over.png": "8329",
	"./cc6-can-we-cool-down.jpg": "e4a2",
	"./ii1-shifting investment.png": "f47f",
	"./ii2-greening-the-pandemic.png": "f2aa",
	"./ii3-social-ecological-transformation.png": "f144",
	"./ii4-gender-perspectives.png": "3674",
	"./ii5-towards-a-just-transition.png": "5e82",
	"./ii6-can-we-cool-down.jpg": "d9ab",
	"./lp1-social-ecological-transformation.png": "4435",
	"./lp2-shifting-investment.png": "a6fe",
	"./lp3-energy-transition.jpg": "e380",
	"./migrant_worker_urban_vietnam_binh_dang_fes (11).jpg": "9897",
	"./placeholder.png": "c0a0",
	"./sk_hyunwoo_23.jpg": "c487",
	"./vn-2-shifting-investment.jpg": "5ca9",
	"./vn1-social-ecological-transformation.png": "7afe",
	"./vn3-coal-based-power.jpg": "f494",
	"./vn4-housing-and-transportation.jpg": "13e9",
	"./vn5-telling-the-energy-story.jpg": "c665",
	"./vn6-vietnam_s-environmental-policies.jpg": "93a0",
	"./vn6-vietnams-environmental-policies.jpg": "0973"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c0a2";